import { render } from "./newContact.vue?vue&type=template&id=d8e2bf42"
import script from "./newContact.vue?vue&type=script&lang=js"
export * from "./newContact.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__